import { AppVariantConfig } from '@/types/app-config';

export const customVariant: AppVariantConfig = {
  id: 'custom',
  name: 'Custom',
  description: 'Custom configuration based on project features',
  defaultRoute: 'home',
  appModules: {}, // Will be populated dynamically
  adminModules: {} // Will be populated dynamically
}; 